import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { APP_ROUTES } from './app-routing';

@NgModule({
  imports: [BrowserModule, HttpClientModule, RouterModule.forRoot(APP_ROUTES), AppComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
